import { NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { HeaderContainer } from "./style";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import logo from "../../imgs/logo.svg";
import { Link } from "react-scroll";
// import { useGtm } from "react-gtm-module";

export default function Header() {
  const [menuIsVisible, setMenuIsVisible] = useState(false);
  const [animation, setAnimation] = useState(false);
  const path = useLocation().pathname;
  useEffect(() => {
    function scrollUp() {
      window.scrollTo(0, 0);
    }
    scrollUp();
  }, [path]);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 1000) {
        setAnimation(true);
      }
    });
  }, []);
  // function disables() {
  //   if (path === "/agenda-ja") {
  //     window.style.display = "none";
  //   }
  // }

  // const { dataLayer } = useGtm();

  const handleClick = () => {
    // dataLayer.push({ event: "clique_no_botao" });
    // Adicione outras informações relevantes sobre o evento, se necessário
  };
  return (
    <>
      <HeaderContainer
        isVisible={menuIsVisible}
        isAnimation={animation}
        // className=${disables()}
        // className={`${path === "/agenda-ja" ? " none" : "none"}`}
      >
        <div className="logo">
          <NavLink to="/">
            <img src={logo} alt="logo" />
          </NavLink>
        </div>
        <a
          href="https://api.whatsapp.com/send?phone=5511912076607"
          target="blanked"
          className="link"
        >
          <button className="buttonHeader" onClick={handleClick}>
            Entrar em contato
          </button>
        </a>
      </HeaderContainer>
    </>
  );
}
